import {
    Button,
    Image,
    HStack,
    Box,
    VStack,
    IconButton,
    Text,
} from "@chakra-ui/react";
import { SetStateAction, useEffect, useState } from "react";
import GMainImageComponent from "./GaraazZoomer";
import React from "react";
import Draggable from "react-draggable";
import { RiCloseFill } from "react-icons/ri";
import { Resizable } from "re-resizable";
import { fileDownloadImage } from "../enums";
import { HiDownload } from "react-icons/hi";

type Props = {
    mediaFiles: any[];
    isOpen: boolean;
    onClose: () => void;
    mainImage: any;
};

function FileViewerModal(props: Props) {
    const { mediaFiles, isOpen, onClose, mainImage } = props;
    const [modalMainImageSrc, setModalMainImageSrc] = useState(mainImage);

    useEffect(() => {
        setModalMainImageSrc(mainImage);
    }, [mainImage]);

    function handleClickVerticalImages(item: any) {
        setModalMainImageSrc(item);
    }

    const handleDownload = (path: string) => {
        window.open(path, "_blank");
    };

    return (
        <Draggable handle=".handle, .handle-footer">
            <Resizable
                defaultSize={{ width: "70vw", height: "90vh" }}
                style={{
                    zIndex: 10000,
                    position: "fixed",
                    margin: "auto",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    display: `${isOpen === true ? "flex" : "none"}`,
                }}
                minHeight={"50vh"}
                minWidth={"30vw"}
            >
                <Box
                    height={"100%"}
                    width={"100%"}
                    display={"flex"}
                    flexDirection={"column"}
                    backgroundColor={"white"}
                    border={"1px solid lightgrey"}
                    padding={"15px"}
                    borderRadius={"7px"}
                >
                    <Box
                        width={"100%"}
                        height={"fit-content"}
                        display={"flex"}
                        justifyContent={"space-between"}
                        className="handle"
                        cursor={"grab"}
                        alignItems={"center"}
                        flex={0}
                    >
                        <Text fontSize={"xl"} fontWeight={"bold"} color={"black"}>
                            Proof Files
                        </Text>
                        <IconButton
                            icon={<RiCloseFill style={{ fontSize: "2em" }}></RiCloseFill>}
                            aria-label="Close"
                            onClick={onClose}
                        />
                    </Box>

                    <Box width={"100%"} flex={1} mt={5} mb={5} position={"relative"}>
                        <HStack
                            height={"100%"}
                            width={"100%"}
                            spacing={4}
                            alignItems="stretch"
                        >
                            <VStack
                                width={"120px"}
                                height={"100%"}
                                justifyContent={"flex-start"}
                                alignItems={"center"}
                                overflowY={"auto"}
                                spacing={3}
                                pr={2}
                                sx={{
                                    '&::-webkit-scrollbar': {
                                        width: '4px',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: 'gray.200',
                                        borderRadius: 'full',
                                    },
                                }}
                            >
                                {mediaFiles?.map((item: any, index: number) => {
                                    const isImage = item?.mimeType?.startsWith("image");
                                    const isSelected = modalMainImageSrc?.path === item.path;
                                    return (
                                        <Box
                                            key={index}
                                            cursor="pointer"
                                            onClick={() => handleClickVerticalImages(item)}
                                            border={isSelected ? "3px solid #3182ce" : "3px solid lightgrey"}
                                            borderRadius="md"
                                            overflow="hidden"
                                            transition="all 0.2s"
                                            _hover={{ borderColor: isSelected ? "#3182ce" : "gray.400" }}
                                            flexShrink={0}
                                        >
                                            <Image
                                                src={isImage ? item.path : fileDownloadImage}
                                                height={"80px"}
                                                width={"100px"}
                                                objectFit="cover"
                                                fallbackSrc={fileDownloadImage}
                                                onMouseEnter={() => {
                                                    handleClickVerticalImages(item);
                                                }}
                                            />
                                        </Box>
                                    );
                                })}
                            </VStack>
                            <Box flex={1} height={"100%"} position={"relative"} border="1px solid" borderColor="gray.100" borderRadius="md" overflow="hidden">
                                {modalMainImageSrc?.mimeType?.startsWith("image") ? (
                                    <GMainImageComponent
                                        imagePath={modalMainImageSrc.path}
                                        handleModalOpen={() => { }}
                                    />
                                ) : (
                                    <Box
                                        width={"100%"}
                                        height={"100%"}
                                        display="flex"
                                        flexDirection="column"
                                        alignItems="center"
                                        justifyContent="center"
                                        bg="gray.50"
                                    >
                                        <Image
                                            src={fileDownloadImage}
                                            maxWidth="200px"
                                            objectFit="contain"
                                            mb={4}
                                        />
                                        <Text color="gray.500" mb={4}>File preview not available</Text>
                                        <Button
                                            leftIcon={<HiDownload />}
                                            colorScheme="blue"
                                            onClick={() => handleDownload(modalMainImageSrc.path)}
                                        >
                                            Download File
                                        </Button>
                                    </Box>
                                )}
                            </Box>
                        </HStack>
                    </Box>

                    <Box
                        width={"100%"}
                        display={"flex"}
                        flex={0}
                        position={"static"}
                        cursor={"grab"}
                        justifyContent={"flex-end"}
                        className="handle-footer"
                    >
                        <Button colorScheme="blue" onClick={onClose}>
                            OK
                        </Button>
                    </Box>
                </Box>
            </Resizable>
        </Draggable>
    );
}

export default FileViewerModal;
